




























import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import ChecksPopup from "./ChecksPopup.vue";
import ImportantCell from "./ImportantCell.vue";
import type { Hint, Items, Location } from "@/store/tracker_important/state";
import { formatItem } from "@/util";

const tracker = namespace("tracker_important");
const settings = namespace("settings");

@Component({
  components: {
    ChecksPopup,
    ImportantCell,
  },
})
export default class ImportantLocation extends Vue {
  @Prop(String) file!: string;

  @tracker.State items!: Items;
  @tracker.State foundChecks!: { [key: string]: string[] };
  @tracker.State hints!: Hint[];
  @tracker.State selectedLocation!: string;
  @tracker.Action primary!: Function;
  @tracker.Action disable!: Function;
  @tracker.Action other!: Function;
  @tracker.Action undoCheck!: Function;
  @tracker.Mutation selectLocation!: Function;

  @settings.State("important") settings!: { [key: string]: any };

  showChecks = false;

  get cell(): Location {
    return this.$store.getters["tracker_important/cell"](this.file);
  }

  get hinted(): number {
    if ((this.items.all[this.file] as Location).totalChecks === -1) {
      // not hinted
      return 0;
    }

    const reportLocation = this.hints.find(h => h.location === this.file)?.report;
    if (!reportLocation) return 0;

    return reportLocation === "Free" ||
      (this.items.all[reportLocation] as Location).totalChecks !== -1
      ? 1 // World is hinted, or it was goa/critical extra, which also counts
      : // Otherwise, check if we know it will be hinted but we just don't have the report yet
        // i.e., it has a proof or hints a world with a proof
        -this.$store.getters["tracker_important/willBeHinted"](reportLocation);
  }

  get willBeHinted(): boolean {
    return (
      // we are only interested in whether it will be hinted when it hasn't already
      (this.items.all[this.file] as Location).totalChecks === -1 &&
      this.$store.getters["tracker_important/willBeHinted"](this.file)
    );
  }

  get otherFile(): string | undefined {
    const other = this.cell.other;
    if (Array.isArray(other)) {
      return other[this.cell.otherLevel - 1];
    }

    return other;
  }

  styledIcon(file: string): string {
    const cell = this.$store.getters["tracker_important/cell"](file);
    const style = this.$store.state.settings.iconStyles[cell.category]?.value;

    if (style === cell.categoryExclude) {
      return `default/${file}`;
    }

    switch (style) {
      case "Minimal":
        return `minimal/${file}`;
      case "Classic":
        return `classic/${file}`;
      default:
        return `default/${file}`;
    }
  }

  handleClick(event: MouseEvent): void {
    if (this.settings.preselectWorld) {
      if (this.file === this.selectedLocation) {
        this.selectLocation("Free");
      } else {
        this.selectLocation(this.file);
      }
    } else {
      const shift = event.shiftKey;

      this.primary({ cell: this.file, offset: 1, shift });
      console.log("Clicked on", formatItem(this.file) + (event.shiftKey ? " (shift)" : ""));
    }
  }

  removeCheck(): void {
    const checks = this.foundChecks[this.file];
    if (checks.length) {
      this.undoCheck({ check: checks[checks.length - 1], location: this.file });
    }
  }

  showOther(event: MouseEvent) {
    this.other({ cell: this.file, offset: event.ctrlKey ? -1 : 1 });
  }
}
